// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__34w3b","lds-ripple":"Loader_lds-ripple__2rzZH","center":"Loader_center__2-ST6"};